
function createWebSocket() {
  const location = document.location;

  return new WebSocket(
    `${location.protocol === 'https:' ? 'wss' : 'ws'}://${location.hostname}${location.port ? ':' + location.port : ''}/ws1`
  );
}

export {createWebSocket}